var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-text-field", {
    class: _vm.isBorderOn ? "_border" : "",
    attrs: {
      hidden: "",
      readonly: "",
      flat: "",
      light: "",
      "error-messages": _vm.message,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }